import React, { useEffect, useState } from 'react'
import CenterModal from '../../../components/Modals/center-modal'
import SmallCenterModal from '../../../components/Modals/small-center-modal'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as TokenIcon } from '../../../assets/icons/token.svg';
import { ReactComponent as BookingIcon } from '../../../assets/icons/booking.svg';
import { ReactComponent as TokenExpireIcon } from '../../../assets/plus_icon/token_expire.svg'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as PendingIcon } from '../../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as PaidIcon } from '../../../assets/plus_icon/incentive_paid.svg';
import { ReactComponent as TagExtendedIcon } from '../../../assets/plus_icon/tag_extend.svg';
import moment from 'moment';
import { getTimeline } from '../../../services/private/plus.leads.service';
import { ReactComponent as TimelineIcon } from '../../../assets/plus_icon/timeline_icon.svg'
import { toINRFormat } from '../../../helpers/helpers';

const TIMELINE_EVENT_TYPE = {
    SITEVISIT: "SITE_VISIT",
    BOOKINGDONE: 'BOOKING_DONE',
    BOOKINGCANCELLED: 'BOOKING_CANCELLED',
    TOKENDONE: 'EOI_DONE',
    TOKENCANCELLED: 'EOI_CANCELLED',
    LEAD_TAG: 'LEAD_TAG'
}

const SV_ACTION = {
    RESCHEDULED: 'Rescheduled',
    SCHEDULED: 'Scheduled',
    COMPLETED: 'Completed'
}

const Timeline = ({ show, closeModal, uuid }) => {

    const [eventTimeline, setEventTimeline] = useState([]);

    const getEventTimeline = async () => {
        const res = await getTimeline(uuid)
        if (res.data.status === 200) {
            console.log(res.data.data.timeline, 'data timeline') //No timeline
            setEventTimeline(res?.data?.data?.timeline)
        }
    }

    useEffect(() => {
        if (uuid) {
            getEventTimeline();
        }
    }, [uuid])

    const showTimeline = (timeline) => {
        switch (timeline.event_type) {
            case TIMELINE_EVENT_TYPE.SITEVISIT:
                return <div className='!w-full' key={timeline.id}>
                    <div className="flex !w-full">
                        <div className="flex flex-col items-center !mr-2">
                            <div className="">
                                <TimelineIcon />
                            </div>
                            <div className='border-l-2 !my-1 !h-full'></div>
                        </div>
                        <div className="righ !w-full !p-1">
                            <div className="timeline-box-shadow rounded-xl !p-4">
                                <div className='flex items-center !mb-4'>
                                    <div className='h-8 w-8 rounded-full bg-[#684EFB1A]/10 flex items-center justify-center'>
                                        <LocationIcon className=' fill-blue-900 h-6 w-6' />
                                    </div>
                                    <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                        Sitevisit {SV_ACTION[timeline.action]}
                                    </h2>
                                </div>
                                <div className='w-full flex items-center justify-between'>
                                    {timeline?.schedule_date && <p className='flex flex-col text-sm '>
                                        <span className='text-black700'>Scheduled </span>
                                        <span className='text-gray700'>{moment(timeline?.schedule_date).format('hh:mm a Do MMM YYYY')}</span>
                                    </p>}
                                    {timeline?.completed_date && <p className='flex flex-col text-sm'>
                                        <span className='text-black700'>Completed </span>
                                        <span className='text-gray700'>{moment(timeline?.completed_date).format('hh:mm a Do MMM YYYY')}</span>

                                    </p>}
                                </div>

                                <p className='flex flex-col text-sm !mt-4'>
                                    <span className='text-black700'>Comments :</span>
                                    <span>{timeline?.remarks || '-'}</span>
                                </p>

                            </div>
                            <p className='fz12 ro fw-regular black-dark-700 mb-0 mt-8 float-right'>{timeline?.sm_name ? `${timeline?.sm_name} •` : ''} {moment(timeline.created_on).format('h:mm a, Do MMM YYYY')}</p>
                        </div>
                    </div >
                </div>
            case TIMELINE_EVENT_TYPE.BOOKINGDONE:
                return <div className='!w-full' key={timeline.id}>
                    <div className="flex !w-full">
                        <div className="flex flex-col items-center !mr-2">
                            <div className="">
                                <TimelineIcon />
                            </div>
                            <div className='border-l-2 !my-1 !h-[calc(100%-24px)]'></div>
                        </div>
                        <div className="righ !w-full !p-1">
                            <div className="timeline-box-shadow rounded-xl !p-4">
                                <div className='flex items-center !mb-4'>
                                    {timeline.action === 'INSERT' && <div className='h-8 w-8 rounded-full bg-[#684EFB] flex items-center justify-center'>
                                        <BookingIcon className='fill-white h-5 w-5' />
                                    </div>}
                                    {timeline.action === 'INSERT' && <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                        Booking Done
                                    </h2>}
                                    {timeline.action === 'CANCELLED' &&
                                        <div className='h-8 w-8 rounded-full bg-[#FF974A] flex items-center justify-center'>
                                            <BookingIcon className='fill-white h-5 w-5' />
                                        </div>
                                    }
                                    {timeline.action === 'CANCELLED' && <h2 className='text-sm font-bold  black-dark-800 ml-2.5 mb-0'>
                                        Booking Cancelled
                                    </h2>}
                                </div>

                                <div className='w-full !p-2 bg-black100 rounded-xl'>
                                    <p className='flex text-sm justify-between '>
                                        <span className='text-black700'>Date </span>
                                        <span className='text-gray700'>{moment(timeline?.booking_date).format('hh:mm a Do MMM YYYY')}</span>
                                    </p>
                                    
                                    <p className='flex text-sm justify-between'>
                                        <span className='text-black700'>RM </span>
                                        <span className='text-gray700'>{timeline?.cm_name ? timeline?.cm_name : '-'}</span>
                                    </p>
                                </div>
                                <p className='flex flex-col text-sm !mt-4'>
                                    <span className='text-black700'>Comments :</span>
                                    <span>{timeline?.remarks || '-'}</span>
                                </p>
                            </div>
                            <p className='fz12 ro fw-regular black-dark-700 mb-0 mt-8 float-right'>{timeline?.sm_name ? `${timeline?.sm_name} •` : ''} {moment(timeline.created_on).format('h:mm a, Do MMM YYYY')}</p>
                        </div>
                    </div >
                </div>

            case TIMELINE_EVENT_TYPE.TOKENDONE:
                return <div className='!w-full' key={timeline.id}>
                    <div className="flex !w-full">
                        <div className="flex flex-col items-center !mr-2">
                            <div className="">
                                <TimelineIcon />
                            </div>
                            <div className='border-l-2 !my-1 !h-full'></div>
                        </div>
                        <div className="righ !w-full !p-1">
                            <div className="timeline-box-shadow rounded-xl !p-4">
                                <div className='flex items-center !mb-4'>
                                    {timeline.action === 'INSERT' && <div className='h-8 w-8 rounded-full bg-[#5256FB] flex items-center justify-center'>
                                        <TokenIcon className='fill-white h-5 w-5' />
                                    </div>}
                                    {timeline.action === 'INSERT' && <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                        Token Done
                                    </h2>}
                                    {timeline.action === 'CANCELLED' && <div className='h-8 w-8 rounded-full bg-[#FF974A] flex items-center justify-center'>
                                        <TokenExpireIcon className='fill-white h-5 w-5' />
                                    </div>}
                                    {timeline.action === 'CANCELLED' && <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                        Token Cancelled
                                    </h2>}
                                </div>

                                <div className='w-full !p-2 bg-black100 rounded-xl'>
                                    <p className='flex text-sm justify-between '>
                                        <span className='text-black700'>Date </span>
                                        <span className='text-gray700'>{moment(timeline?.token_date).format('hh:mm a Do MMM YYYY')}</span>
                                    </p>
                                   
                                    <p className='flex text-sm justify-between'>
                                        <span className='text-black700'>RM </span>
                                        <span className='text-gray700'>{timeline?.cm_name ? timeline?.cm_name : '-'}</span>
                                    </p>
                                </div>

                                <p className='flex flex-col text-sm !mt-4'>
                                    <span className='text-black700'>Comments :</span>
                                    <span>{timeline?.remarks || '-'}</span>
                                </p>

                            </div>
                            <p className='fz12 ro fw-regular black-dark-700 mb-0 mt-8 float-right'>{timeline?.sm_name ? `${timeline?.sm_name} •` : ''} {moment(timeline.created_on).format('h:mm a, Do MMM YYYY')}</p>
                        </div>
                    </div >
                </div>
            case TIMELINE_EVENT_TYPE.LEAD_TAG:
                return <div className='!w-full' key={timeline.id}>
                    <div className="flex !w-full">
                        <div className="flex flex-col items-center !mr-2">
                            <div className="">
                                <TimelineIcon />
                            </div>
                            <div className='border-l-2 !my-1 !h-[calc(100%-24px)]'></div>
                        </div>
                        <div className="righ !w-full !p-1">
                            <div className="timeline-box-shadow rounded-xl !p-4">
                                <div className='flex items-center !mb-4'>
                                    <div className='h-8 w-8 '>
                                        <TagExtendedIcon />
                                    </div>
                                    <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                        Tagging Extended
                                    </h2>

                                </div>

                                <div className='w-full !p-2 bg-black100 rounded-xl'>
                                    <p className='flex text-sm justify-between '>
                                        <span className='text-black700'>Validity: </span>
                                        <span className='text-gray700'>{moment(timeline?.booking_date).format('hh:mm a Do MMM YYYY')}</span>
                                    </p>
                                    <p className='flex text-sm justify-between'>
                                        <span className='text-black700'>CP User: </span>
                                        <span className='text-gray700'>{timeline?.cm_name ? timeline?.cm_name : '-'}</span>
                                    </p>
                                    <p className='flex text-sm justify-between'>
                                        <span className='text-black700'>RM </span>
                                        <span className='text-gray700'>{timeline?.sm_name ? timeline?.sm_name : '-'}</span>
                                    </p>
                                </div>
                                <p className='flex flex-col text-sm !mt-4'>
                                    <span className='text-black700'>Comments :</span>
                                    <span>{timeline?.remarks || '-'}</span>
                                </p>
                            </div>
                            <p className='fz12 ro fw-regular black-dark-700 mb-0 mt-8 float-right'>{timeline?.sm_name ? `${timeline?.sm_name} •` : ''} {moment(timeline.created_on).format('h:mm a, Do MMM YYYY')}</p>
                        </div>
                    </div >
                </div>
        }
    }

    const displayTimeline = () => {
        if (eventTimeline?.length > 0) {
            return eventTimeline.map(event => {
                return showTimeline(event)
            })
        }
    }
    return (
        <SmallCenterModal show={show} closeModal={closeModal} dialogClassName='w-[400px] modal-radius'>
            <div className=''>
                <div className='flex items-center justify-between timeline-title-box-shadow !p-4'>
                    {/* <div className='h-12 w-12 rounded-xl bg-[#684EFB1A]/10 flex items-center justify-center'>
                        <LocationIcon className=' fill-blue-900 h-12 w-12' />
                    </div> */}
                    <h3 className='text-lg font-semibold'>Timeline</h3>
                    <button className='border-0 bg-tr ' onClick={closeModal}><CloseIcon /></button>
                </div>
                <div className='h-[50vh] overflow-auto !px-6 !py-4'>
                    {displayTimeline()}

                    {/* <div className='!w-full !mt-4'>
                        <div className="flex !w-full">
                            <div className="">                                
                            </div>
                            <div className="righ !w-full">
                                <div className="timeline-box-shadow rounded-xl !p-4">
                                    <div className='flex items-center !mb-4'>
                                        <div className='h-8 w-8 rounded-full bg-[#684EFB1A]/10 flex items-center justify-center'>
                                            <LocationIcon className=' fill-blue-900 h-6 w-6' />
                                        </div>
                                        <h2 className='text-sm font-bold  black-dark-800 ml-2.5 !mb-0'>
                                            Sitevisit Completed
                                        </h2>
                                    </div>
                                    <div className='w-full flex items-center justify-between'>
                                        <p className='flex flex-col text-sm '>
                                            <span className='text-black700'>Scheduled </span>
                                            <span className='text-gray700'>4:00 pm, 6th Sep 2024</span>
                                        </p>
                                        <p className='flex flex-col text-sm'>
                                            <span className='text-black700'>Completed </span>
                                            <span className='text-gray700'>4:00 pm, 6th Sep 2024</span>

                                        </p>
                                    </div>
                                    <p className='flex flex-col text-sm'>
                                        <span className='text-black700'>Comments :</span>
                                        <span>2 the client is looking for 3 BHK in a luxury apartment buildings. high floor </span>
                                    </p>
                                </div>                                
                            </div>
                        </div >
                    </div> */}
                </div>
            </div>
        </SmallCenterModal>
    )
}

export default Timeline